module.exports = __webpack_public_path__ + "static/prosociedad@2x-651e85bcc9fd6b72f279d647d29f1e4a.png";